import { __assign } from "tslib";
import * as React from 'react';
import View from './view-pc';
export function CnAddress(props) {
    return React.createElement(View, __assign({}, props));
}
CnAddress.displayName = 'CnAddress';
